<template>
    <VueMultiselect
        :options="options"
        :class="[`${getColoreStato(modelValue)} next-vue-multiselect-stato`, isOpen?'w-80' : '']"
        selectLabel=""
        deselectGroupLabel=""
        track-by="id" label="descrizione"
        deselectLabel=""
        selectGroupLabel=""
        @select="$emit('select', $event)"
        @open="isOpen = true"
        @close="isOpen = false"
        :modelValue="modelValue"
        :disabled="!options?.length"
    >
        <template v-slot:option="{option}">{{ getLabelStato(option) }}</template>
        <template v-slot:singleLabel="{option}">{{ getLabelStato(option) }}</template>
    </VueMultiselect>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import { Watch } from 'vue-property-decorator/lib/decorators/Watch';
import sottoProgettiManager from "../api/SottoProgetti";

@Options({
    name: 'SelectStato',
    inject: ['getColoreStato', 'getLabelStato'],
    components: {},
    props: {
        modelValue: {
            type: Object
        },
        sottoprogettoId:[String,Number]
    }
})
export default class SelectStato extends Vue {
    stato!: number
    modelValue!: number
    isOpen = false
    sottoprogettoId!:number
    options = []

    @Watch('modelValue')
    changeValue(){
        this.fetchPossibiliStati();
    }

    created(){
        this.fetchPossibiliStati()
    }

    fetchPossibiliStati(){
        sottoProgettiManager.getStatiPossibili(this.sottoprogettoId).then((res)=>{
            this.options = res.data
        })
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
